import { EventTypes } from "../eventtypes";
import { CallBack } from "../../Models/callbackfunction";
interface IModalHelper {
    showModal(url: string, btnId: string, callback: CallBack): void;
    showPopUp(url: string): void;
}
class ModalHelper implements IModalHelper {
    constructor(public ModalDivId: string) {
    }

    showPopUp(url: string): void {
        let obj = this;
        let modalId: HTMLDivElement | undefined = <HTMLDivElement>(document.getElementById(this.ModalDivId) as HTMLDivElement);
        if (modalId) {
            $("#" + obj.ModalDivId).load(url, function () {
                $("#" + obj.ModalDivId).modal();
            });
        }
    }
    showModal(url: string, btnId: string, callback: CallBack): void {
        let obj = this;
        let modalId: HTMLDivElement | undefined = <HTMLDivElement>(document.getElementById(this.ModalDivId) as HTMLDivElement);
        if (modalId) {
            $("#" + obj.ModalDivId).load(url, function () {
                $("#" + obj.ModalDivId).modal();
                let saveButton: HTMLDivElement | undefined = <HTMLDivElement>(document.getElementById(btnId) as HTMLDivElement);
                if (saveButton) {
                    saveButton!.addEventListener(EventTypes.click, (event) => {
                        if (callback !== null) {
                            event.preventDefault();
                            if (callback && typeof callback === "function") {
                                callback();
                            }
                        }
                    });
                }
                //initialize if needed 
                //$('.datepicker').datepicker();  
            });
        }
    }
}
export {IModalHelper, ModalHelper}
